import axios from 'axios'

const tempToken = 'MLY|27225188017164487|988b5047ac6af0a55e8a4455e9f38b1b'

function gradeImages(mapyResp) {
  const scores = mapyResp?.data?.data?.map(image => image?.detections?.data?.reduce(
    (accumulator, current) => accumulator + current?.value?.includes('structure--building'),0,))
  //console.log (scores)
  return scores.indexOf(Math.max(...scores))
}
//'&detections=structure--building'+ 69112695372
export function getStreetView (lat, long) {
  const url = "https://graph.mapillary.com/images?access_token="+tempToken+'&detections=structure--building'+
    "&fields=id,geometry,captured_at,compass_angle,detections,detections.value&lat="+lat+"&lng="+long+"&limit=5"
  return axios.get(url)
  .then (resp => {
    //console.log (resp)
    const best = gradeImages(resp)
    const imageId = resp?.data?.data[best]?.id
    if (!imageId)
      return undefined
    const imageURL = "https://graph.mapillary.com/"+imageId+"?access_token="+tempToken+"&fields=thumb_original_url"
    return axios.get (imageURL)
    .then (resp => {
      //console.log (resp)
      return <img src={resp?.data?.thumb_original_url} alt="Street View" height='222px' width='auto'/>
    })
  })
  .catch (err => {
    console.log (err)
    return undefined
  })
}